document.addEventListener( 'DOMContentLoaded', function () {
	window.dataLayer = window.dataLayer || [];

	if ( videojs && videojs.getPlayer( 'hmBrightcove' ) ) {
		videojs.getPlayer( 'hmBrightcove' ).on( 'playing', function () {
			let myPlayer = this;
			let isAudio = document.querySelector( '.wp-block-hm-brightcove-with-tracking.video__id.is-audio' );
			let playerEvent = isAudio ? 'audio_start' : 'video_start';
			let playEventLogged = false;

			const videoTitle = myPlayer.mediainfo.name;
			const playerId = myPlayer.bcinfo.playerId;
			const videoId = myPlayer.mediainfo.id;

			if ( !playEventLogged ) {
				window.dataLayer.push({
					'event': playerEvent,
					'videoTitle': videoTitle,
					'playerId': playerId,
					'videoId': videoId
				} );
				playEventLogged = true;
			}
		} );
	}
} );